module.exports = __webpack_public_path__ + "img/17_27.c5347360.png";